import * as React from 'react';
export var ChallengesContext = React.createContext(null);
export var ChallengesProvider = ChallengesContext.Provider;
export var CitationsContext = React.createContext(null);
export var CitationsProvider = CitationsContext.Provider;
export var ColorsContext = React.createContext(null);
export var ColorsProvider = ColorsContext.Provider;
export var EconomiesContext = React.createContext([]);
export var EconomiesProvider = EconomiesContext.Provider;
export var EntityTypesContext = React.createContext(null);
export var EntityTypesProvider = EntityTypesContext.Provider;
export var EventsContext = React.createContext(null);
export var EventsProvider = EventsContext.Provider;
export var ExpertiseLevelsContext = React.createContext(null);
export var ExpertiseLevelsProvider = ExpertiseLevelsContext.Provider;
export var FeedEntriesContext = React.createContext(null);
export var FeedEntriesProvider = FeedEntriesContext.Provider;
export var GlobalRegionsContext = React.createContext(null);
export var GlobalRegionsProvider = GlobalRegionsContext.Provider;
export var HorizonTypesContext = React.createContext(null);
export var HorizonTypesProvider = HorizonTypesContext.Provider;
export var IndicatorGroupsContext = React.createContext(null);
export var IndicatorGroupsProvider = IndicatorGroupsContext.Provider;
export var IndicatorsContext = React.createContext(null);
export var IndicatorsProvider = IndicatorsContext.Provider;
export var KeyIssuesContext = React.createContext(null);
export var KeyIssuesProvider = KeyIssuesContext.Provider;
export var MenusContext = React.createContext(null);
export var MenusProvider = MenusContext.Provider;
export var ObjectivesContext = React.createContext(null);
export var ObjectivesProvider = ObjectivesContext.Provider;
export var OrganisationsContext = React.createContext(null);
export var OrganisationsProvider = OrganisationsContext.Provider;
export var OrganisationTypesContext = React.createContext(null);
export var OrganisationTypesProvider = OrganisationTypesContext.Provider;
export var PagesContext = React.createContext(null);
export var PagesProvider = PagesContext.Provider;
export var PeopleContext = React.createContext(null);
export var PeopleProvider = PeopleContext.Provider;
export var PostsContext = React.createContext(null);
export var PostsProvider = PostsContext.Provider;
export var ProfileTypesContext = React.createContext(null);
export var ProfileTypesProvider = ProfileTypesContext.Provider;
export var PromptTemplatesContext = React.createContext([]);
export var PromptTemplatesProvider = PromptTemplatesContext.Provider;
export var SpacesContext = React.createContext([]);
export var SpacesProvider = SpacesContext.Provider;
export var SubTopicsContext = React.createContext(null);
export var SubTopicsProvider = SubTopicsContext.Provider;
export var TopicCitationsContext = React.createContext(null);
export var TopicCitationsProvider = TopicCitationsContext.Provider;
export var TopicFeedEntriesContext = React.createContext(null);
export var TopicFeedEntriesProvider = TopicFeedEntriesContext.Provider;
export var TopicHorizonsContext = React.createContext(null);
export var TopicHorizonsProvider = TopicHorizonsContext.Provider;
export var TopicsContext = React.createContext(null);
export var TopicsProvider = TopicsContext.Provider;
export var TrendPeopleContext = React.createContext(null);
export var TrendPeopleProvider = TrendPeopleContext.Provider;
export var TrendVideosContext = React.createContext(null);
export var TrendVideosProvider = TrendVideosContext.Provider;
export var TrendsContext = React.createContext(null);
export var TrendsProvider = TrendsContext.Provider;
export var VideosContext = React.createContext([]);
export var VideosProvider = VideosContext.Provider;